export default __webpack_public_path__ + "invoice-logo.293d9c4.png";